import {fromEvent as observableFromEvent, forkJoin, Subscription} from 'rxjs';

import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {FrontUserService} from '../../../core/services/frontUsers.service';
import {SelectionModel} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {OrganizationsService} from '../../../core/services/organizations.service';
import {NgxSpinnerService} from 'ngx-spinner';
import { TargetGroupService } from '../../../core/services/targetGroup.service';
import { FuseConfigService } from '../../../core/services/config.service';
import { UserService } from '../../../core/services/users.service';
import { ImportUserComponent } from './importUser/importUser.component';
import { BookEventComponent } from './bookEvent/book-event.component';
import {Router} from '@angular/router';
import {FuseDeleteDialogComponent} from '../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService } from 'ngx-toastr';
import {RewardsToAll} from './addRewardsToAll/rewardsToAll';
import { EventService } from '../../../core/services/event.service';
import {CreditCorrectionAllComponent} from './creditCorrectionAll/credit-correction-all.component';
@Component({
    selector: 'frontusers-page',
    templateUrl: './frontusers.component.html',
    styleUrls: ['./frontusers.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FrontUsersComponent implements OnInit, OnDestroy {
  public filterData: any = {};

  users = [];
  pagination: any = {};
  displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address' ,
    'targetGroup', 'organization', 'canton', 'creditTarget', 'creditTargetCurrent', 'bookedEvents', 'connection', 'sendInvite' ] ;
  targetGroupChoose = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  isOrganizer = false;
  isSubCountry = false;
  isCountry = false;
  selection = new SelectionModel<any>(true, []);
  hideButton = false;
  userFilters;
  defUserFilters;
  _pageIndex = 0;
  _perPage = 50;
  _sort = 'name';
  _direction = 'asc';
  _search = '';
  firstPaginatorEmit = true;
  selectedVal = 'hide';
  adminUserEmail = '';

  checkedUsers = [];
  eCall = false;
  whatsapp = false;

  organizationId;

  getUserindex;

  chosenCity = [];
  platformId;
  public subscription = new Subscription();

  constructor (private http: HttpClient , private usersService: FrontUserService , private spinner: NgxSpinnerService ,
               private organizationService: OrganizationsService, public snackBar: MatSnackBar,
               private targetService: TargetGroupService, private fuseConfig: FuseConfigService, private router: Router ,
               public _userService: UserService, public dialog: MatDialog, private toastr: ToastrService,
               public eventService: EventService) {
    this.fuseConfig.userEmail.subscribe((res: any) => {
      if (res) {
        this.adminUserEmail = res;
      }
    });
    this.fuseConfig.eCall.subscribe(res => {
      if (res && res !== 'null') {
        this.eCall = true;
      }
    });
    this.fuseConfig.whatsapp.subscribe(res => {
      if (res && res !== 'null') {
        this.whatsapp = true;
      }
    });
    this.subscription.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        if (res.id !== this.platformId && this.platformId) {
          this.platformId = res.id;
          this.fetchData();
        }
        this.platformId = res.id;
      }
    }));
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address'  , 'targetGroup',
          'creditTarget', 'creditTargetCurrent', 'bookedEvents', 'connection', 'sendInvite' ] ;
        this.isOrganizer = true;
      }
      if (res && res === 'subCountryAdmin') {
        this.displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address'  , 'targetGroup', 'organization',
          'creditTarget', 'creditTargetCurrent',  'bookedEvents', 'connection', 'sendInvite'] ;
        this.isOrganizer = false;
      }
      if (res && res === 'countryAdmin') {
        this.displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address'  , 'targetGroup', 'organization',
          'canton', 'creditTarget', 'creditTargetCurrent', 'bookedEvents', 'connection', 'sendInvite' ] ;
        this.isOrganizer = false;
      }
    });
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit () {
    this.spinner.show();
    let sortFromLS: any = localStorage.getItem('frontUserSort');
    let sortDirFromLS: any = localStorage.getItem('frontUserSortDirection');
    if (sortFromLS && sortDirFromLS) {
      this._sort = sortFromLS;
      this._direction = sortDirFromLS;
    }
    this._pageIndex = +localStorage.getItem('frontUserPageIndex') ? +localStorage.getItem('frontUserPageIndex') : 0;
    this._perPage = +localStorage.getItem('frontUserPageSize') ? +localStorage.getItem('frontUserPageSize') : 25;
    this._search = localStorage.getItem('frontUserSearch') ? localStorage.getItem('frontUserSearch') : '';
    if (this._search && this._search !== null && this._search !== 'null') {
      this.filter.nativeElement.value = this._search;
    }
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
        && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          localStorage.setItem('frontUserSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollFU();
          this.fetchData();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          localStorage.setItem('frontUserSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollFU();
          this.fetchData();
        }
      });
    this.filterData.activated = true;
    this.filterData.noActivated = true;
    this.getCountries();
    this.getRole();
    this.getTargetGroups();
    this.alertMsg();
    this.getUserFilters();
    this.usersService.cityIds.subscribe(res => {
      this.chosenCity = res;
    });
  }

  alertMsg() {
    if (this.usersService.addSuccess) {
      this.usersService.addSuccess = false;
      this.snackBar.open('Successfully  added', '', {duration: 2500});
    }
  }

  getRole () {
    this.usersService.getRoles().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.roles = res;
      } else {
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
      } else if (res.length === 1) {
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }
  getTargetGroups () {
    this.targetService.getTargetGroups(false).then((data: any) => {
      this.filterData.targetGroups = data.targetGroups;
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }
  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantons = res;
      } else if (res.length === 1) {
        this.usersService.setCities({selected: true, canton: res[0].id});
        this.getOrganizations();
        delete this.filterData.cantons;
      } else {
        delete this.filterData.cantons;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.usersService.getOrganizationByCantons().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.organizations = res;
      } else if (res.length === 1) {
        this.usersService.setOrganizations({selected: true, organization: res[0].id});
        this.getTags();
        this.fetchData();
        delete this.filterData.organizations;
        this.organizationId = res[0].id;
      } else {
        delete this.filterData.organizations;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getTags() {
    this.usersService.getTagByOrganization().subscribe((res: any) => {
      if (res.length > 0) {
        this.filterData.tags = res;
      } else if (res.length === 1) {
        // this.usersService.setTags(res[ 0 ].id);
        // this.fetchData();
        // delete this.filterData.tags;
      } else {
        delete this.filterData.tags;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters (e) {
    console.log(e);
    this.paginator.firstPage();
    this.cleanScrollFU();
    if (e.choose === 'all') {
      delete this.filterData.cantons;
      delete this.filterData.countries;
      delete this.filterData.organizations;
      delete this.filterData.tags;
      delete this.filterData.targetGroups;
      delete this.filterData.roles;
      this.usersService.setToAll();
      this.fetchData();
      this.getCountries();
      this.getRole();
      this.getTargetGroups();
      this.fuseConfig.setActiveFilter(false);
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantons;
      delete this.filterData.organizations;
      delete this.filterData.tags;
      this.getCantons(e.choose.country);
      this.usersService.setCountryId(e.choose.country);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('canton')) {
      delete this.filterData.organizations;
      delete this.filterData.tags;
      this.usersService.setCities(e.choose);
      this.usersService.setOrganizations('clear');
      this.fetchData();
      this.getOrganizations();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('organization')) {
      delete this.filterData.tags;
      this.usersService.setOrganizations(e.choose);
      this.fetchData();
      this.getTags();
      this.fuseConfig.setActiveFilter(true);
    }  else if (e.choose.hasOwnProperty('tag')) {
      this.usersService.setTags(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }  else if (e.choose.hasOwnProperty('targetGroups')) {
      this.usersService.setTargetGroups(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('role')) {
        this.usersService.setRoles(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('activated')) {
      this.usersService.setActivated(e.choose.activated);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('noActivated')) {
      this.usersService.setNoActivated(e.choose.noActivated);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    this.setDataFromFilter(e);
  }

  getUserFilters() {
    this._userService.getFilter('user').subscribe((res: any) => {
      if (res) {
        this.defUserFilters = res;
        this.userFilters = { user: JSON.parse(res.config)};
        const config = JSON.parse(res.config);
        if (Object.keys(config).length) {
          this.fuseConfig.setActiveFilter(true);
        } else {
          this.fuseConfig.setActiveFilter(false);
        }
        if (config.hasOwnProperty('targetGroups')) {
          config.targetGroups.forEach(el => {
            this.usersService.setTargetGroups({targetGroups: el, selected: true});
          });
        }

        if (config.hasOwnProperty('roles')) {
          config.roles.forEach(el => {
            this.usersService.setRoles({role: el, selected: true});
          });
        }

        if (config.hasOwnProperty('tags')) {
          config.tags.forEach(el => {
            this.usersService.setTags({tag: el, selected: true});
          });
        }
        const countryPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('country')) {
            this.usersService.setCountryId(config.country);
            this.organizationService.getCity(+config.country).subscribe((resCanton: any) => {
              if (resCanton.length > 1) {
                this.filterData.cantons = resCanton;
              } else if (resCanton.length === 1) {
                this.usersService.setCities({selected: true, canton: resCanton[0].id});
                this.getOrganizations();
                delete this.filterData.cantons;
              } else {
                delete this.filterData.cantons;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
        const cantonsPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('cantons')) {
            config.cantons.forEach(el => {
              this.usersService.setCities({canton: el, selected: true});
            });
            this.usersService.getOrganizationByCantons().subscribe((resOrg: any) => {
              if (resOrg.length > 1) {
                this.filterData.organizations = resOrg;
              } else if (resOrg.length === 1) {
                this.usersService.setOrganizations(resOrg[ 0 ].id);
                this.fetchData();
                delete this.filterData.organizations;
              } else {
                delete this.filterData.organizations;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
        const organizationPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('organizations')) {
            config.organizations.forEach(el => {
              this.usersService.setOrganizations({organization: el, selected: true});
            });
            this.usersService.getTagByOrganization().subscribe((resTag: any) => {
              if (resTag) {
                this.filterData.tags = resTag;
              }
            } );
            resolve(true);
          } else {
            resolve(true);
          }
        });

        Promise.all([countryPromise, cantonsPromise, organizationPromise]).then(values => {
          console.log(values);
          if (this.isOrganizer && Object.keys(config).length) {
            this.fetchData();
          } else {
            this.fetchData();
          }
        });

      } else {
        this.fuseConfig.setActiveFilter(false);
        this.userFilters = { user: {}};
        this.defUserFilters = '';
        this.fetchData();
      }
    });
  }

  setUserFilters(key, value) {
    // if (this.userFilters && this.userFilters.user && this.userFilters.user[key]) {
      this.userFilters.user[key] = value;
      this._userService.setFilters('user', this.userFilters.user, this.defUserFilters ? this.defUserFilters.id : '')
        .subscribe((res: any) => {
          this.defUserFilters = res;
        });
    // }
  }

  setEmptyUserFilters() {
    this._userService.setFilters('user', {}, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
        this.userFilters = { user: {}};
      });
  }

  setDataFromFilter(e) {
    if (e.choose === 'all') {
      this.userFilters.user = {};
      this.setEmptyUserFilters();
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.userFilters.user['cantons'];
      delete this.userFilters.user['organizations'];
      this.setUserFilters('country', e.choose.country);
    } else if (e.choose.hasOwnProperty('canton')) {
      const _cities = this.usersService.getCities();
      this.setUserFilters('cantons', _cities);
    } else if (e.choose.hasOwnProperty('organization')) {
      const _organizations = this.usersService.getOrganizations();
      this.setUserFilters('organizations', _organizations);
    }else if (e.choose.hasOwnProperty('tag')) {
      const _tags = this.usersService.getTags();
      this.setUserFilters('tags', _tags);
    }
    else if (e.choose.hasOwnProperty('targetGroups')) {
      const _targetGroups = this.usersService.getTargetGroups();
      this.setUserFilters('targetGroups', _targetGroups);
    }
    else if (e.choose.hasOwnProperty('role')) {
      const _role = this.usersService.getRolesIds();
      this.setUserFilters('roles', _role);
    }
  }


  fetchData () {
    this.selection.clear();
    this.checkedUsers = [];
    this.spinner.show();
    const _organizations = this.usersService.getOrganizations();
    if (this.isOrganizer && !_organizations.length) {
      this.getCountries();
    } else {
      let _getUserindex = (new Date()).getTime();
      this.getUserindex = _getUserindex;
      this.usersService.getUsersNew(this._pageIndex + 1, this._perPage, this._sort,
        this._direction, this._search, false, this.platformId).subscribe((res: any) => {
          if (this.getUserindex === _getUserindex) {
            this.users = res.users;
            this.pagination = res.pagination;
            this.spinner.hide();
            this.users.forEach((_user: any) => {
              if (_user.Creditziel && _user.Credits_der_aktuellen_Zielgruppe &&
                +_user.Creditziel >= +_user.Credits_der_aktuellen_Zielgruppe) {
                let rew = this.usersService.getRewards(_user.id, _user.targetGroupId);
                let cred = this.usersService.getUserTG(_user.id, _user.targetGroupId);
                forkJoin([rew, cred]).subscribe((result: any) => {
                  let _rewards = result[0];
                  let data = result[1];
                  for (let i = 0; i < data.subCredit.length; i++) {
                    const creditId = data.subCredit[i].eventTypeId;
                    const creditObject = _rewards.reward.find(
                      item => item.eventTypeId === creditId
                    );
                    if (creditObject && +creditObject.credits < data.subCredit[i].credit) {
                      let index = this.users.findIndex(us => +us.id === _user.id);
                      if (index !== -1) {
                        this.users[index].showCreditsError = true;
                      }
                    }
                  }
                });
              }
            });
            setTimeout(() => {
              let table = document.getElementById('frontUserPage');
              if (table && localStorage.getItem('frontUserScroll')) {
                table.scrollTop = +localStorage.getItem('frontUserScroll');
              }
              let getPageCounter: any = document.getElementsByClassName('fu-page-counter');
              if (getPageCounter.length) {
                getPageCounter[0].innerHTML = `${this._pageIndex + 1} of ${Math.ceil(this.pagination.total / this._perPage)}`;
              } else {
                let matButton: any = document.getElementsByClassName('mat-mdc-paginator-navigation-previous');
                let pageCounter = document.createElement('div');
                pageCounter.className = 'fu-page-counter';
                pageCounter.innerHTML = `${this._pageIndex + 1} of ${Math.ceil(this.pagination.total / this._perPage)}`;
                matButton[0].parentNode.insertBefore(pageCounter, matButton[0].nextSibling);
              }
            }, 500);
          }
      }, error => {
        this.spinner.hide();
      });
    }
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.users.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.users.forEach(row => this.selection.select(row));
    this.checkedUsers = this.selection.selected;
    console.log(this.checkedUsers);
    if (this.checkedUsers && this.checkedUsers.length && this.pagination && this.pagination.total) {
      if (+this.pagination.total > +this._perPage) {
        const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
          width: '300px' ,
          data: {title: 'Choose_all' , message: 'choose_all_msg_user'}
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.spinner.show();
            this.usersService.getUsersNew(1, 100000, this._sort,
              this._direction, this._search).subscribe((res: any) => {
              if (res && res.users) {
                this.checkedUsers = res.users;
              }
              this.spinner.hide();
            }, error => {
              this.spinner.hide();
            });
          }
        });
      }
    }
  }

  checkUser(user, event) {
    if (event.checked) {
      this.checkedUsers.push(user);
    } else {
      let index = this.checkedUsers.findIndex(x => +x.id === +user.id);
      if (index !== -1) {
        this.checkedUsers.splice(index, 1);
      }
    }
    console.log(this.checkedUsers);
  }

  openImportModal() {
    let dialogRef = this.dialog.open(ImportUserComponent, {
      panelClass: 'import-user-dialog',
      width: '450px',
    });
    dialogRef.afterClosed().subscribe(res => {
      this.fetchData();
    });
  }

  openBookModal() {
    let dialogRef = this.dialog.open(BookEventComponent, {
      panelClass: 'book-event-dialog',
      width: '800px',
      data: this.checkedUsers
    });
  }

  openCreditCorretionModal() {
    let dialogRef = this.dialog.open(CreditCorrectionAllComponent, {
      panelClass: 'book-event-dialog',
      width: '800px',
      data: this.checkedUsers,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.fetchData();
      }
    });
  }

  communicationAction(event) {
    if (event.value === 'emailList') {
      this.selectedVal = event.value;
      let emails = [];
      for (let i = 0; i < this.checkedUsers.length; i++) {
        if (this.checkedUsers[i].email) {
          emails.push(this.checkedUsers[i].email);
        }
      }
      if (!emails.length) {
        this.toastr.error('Ausgewählte User haben keine E-Mail' , 'Error!');
        setTimeout(() => {
          this.selectedVal = 'hide';
        }, 500);
        return;
      }
      const to = this.adminUserEmail;
      const cc = '';
      const bcc = emails.join(',');
      const subject = 'Betreff der E-Mail';
      const body = 'Inhalt der E-Mail...';

      this.generateEmltlFile(to, cc, bcc, subject, body);
      setTimeout(() => {
        this.selectedVal = 'hide';
      }, 500);
      return;
    }
    let userWithoutWhatsApp = [];
    this.selectedVal = event.value;
    if (event.value === 'whatsapp') {
      for (let i = 0; i < this.checkedUsers.length; i++ ) {
        if (!this.checkedUsers[i].privacyPolicy || (this.checkedUsers[i].privacyPolicy && !JSON.parse(this.checkedUsers[i].privacyPolicy)['67imas'])) {
          userWithoutWhatsApp.push(this.checkedUsers[i].firstName + ' ' + this.checkedUsers[i].lastName);
        }
      }
    }
    if (!userWithoutWhatsApp.length) {
      let ids = [];
      if (event.value === 'mail') {
        for (let i = 0; i < this.checkedUsers.length; i++ ) {
          if (this.checkedUsers[i].email) {
            ids.push(this.checkedUsers[i].id);
          }
        }
      } else {
        for (let i = 0; i < this.checkedUsers.length; i++ ) {
          ids.push(this.checkedUsers[i].id);
        }
      }
      if (event.value !== 'mail') {
        this.router.navigate(['/pages/communications'], {queryParams: {
          type: event.value,
          ids: ids.toString(),
        }});
      } else {
        if (ids.length) {
          this.router.navigate(['/pages/communications'], {queryParams: {
            type: event.value,
            ids: ids.toString(),
          }});
        } else {
          setTimeout(() => {
            this.selectedVal = 'hide';
          }, 500);
          this.toastr.error('Ausgewählte User haben keine E-Mail' , 'Error!');
        }
      }
    } else {
      this.sendWhatsAppError(userWithoutWhatsApp, event);
    }
  }

  generateEmltlFile(to, cc, bcc, subject, body) {
    const emlContent = `To: ${to}\r\nCc: ${cc || ''}\r\nBcc: ${bcc || ''}\r\nSubject: ${subject}\r\nX-Unsent: 1\r\nContent-Type: text/html\r\n\r\n<html><body>${body}</body></html>`;
    const blob = new Blob([emlContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'email.eml';
    a.click();

    URL.revokeObjectURL(url);
  }

  generateEmlFile(to, cc, bcc, subject, body) {
    const emlContent = `To: ${to}\r\nCc: ${cc || ''}\r\nBcc: ${bcc || ''}\r\nSubject: ${subject}\r\n\r\n${body}`;

    const blob = new Blob([emlContent], { type: 'message/rfc822' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'email.emltpl';
    a.click();

    URL.revokeObjectURL(url);
  }

  sendWhatsAppError (users, event) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '600px' ,
      data: {title: 'user_without_whatsapp' , message: users.join(', ')}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let ids = [];
        for (let i = 0; i < this.checkedUsers.length; i++ ) {
          if (this.checkedUsers[i].privacyPolicy && JSON.parse(this.checkedUsers[i].privacyPolicy)['67imas']) {
            ids.push(this.checkedUsers[i].id);
          }
        }
        this.router.navigate(['/pages/communications'], {queryParams: {
            type: event.value,
            ids: ids.toString(),
          }});
      } else {
        setTimeout(() => {
          this.selectedVal = 'hide';
        }, 500);
      }
    });
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    localStorage.setItem('frontUserPageIndex' , e.pageIndex);
    localStorage.setItem('frontUserPageSize' , e.pageSize);
    this.cleanScrollFU();
    this.fetchData();
  }

  sortData(e) {
    this._sort = e.active;
    this._direction = e.direction;
    if (!e.direction) {
      this._sort = 'name';
      this._direction = 'asc';
    }
    localStorage.setItem('frontUserSort', this._sort);
    localStorage.setItem('frontUserSortDirection', this._direction);
    this.cleanScrollFU();
    this.fetchData();
  }

  onScroll(e) {
    localStorage.setItem('frontUserScroll' , e.target.scrollTop);
  }
  cleanScrollFU() {
    let table = document.getElementById('frontUserPage');
    if (table) {
      table.scrollTop = 0;
      localStorage.setItem('frontUserScroll' , '0');
    }
  }

  download() {
    let url = this.usersService.exportUser();
    const downloadURL = url;
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = downloadURL;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadXLSX() {
    let url = this.usersService.exportUserXLSX();
    const downloadURL = url;
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = downloadURL;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  refreshCredits(){
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '600px' ,
      data: {title: 'refresh_credits_title' , message: 'refresh_credits_text'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.organizationId) {
          this.usersService.refreshCredits(this.organizationId).subscribe(res => {

          });
        }
      }
    });
  }

  addCreditsToAll () {
    let dialogRef;
    dialogRef = this.dialog.open(RewardsToAll , {
      panelClass: 'add-rewards-dialog',
      width: '70vw'
    });
    dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          let data = {eventTypeId: '' , credits: '' , type: '' , fronUserIds: [] , comment: '', targetGroupId: ''};
          data.eventTypeId = response.eventType;
          data.credits = response.credits;
          data.comment = response.comment;
          data.targetGroupId = response.targetGroup;
          data.type = 'custom';
          data.fronUserIds = this.checkedUsers.map(el => el.id);
          this.spinner.show();
          this.usersService.addRewardsToAll(data).subscribe((res) => {
            if (res) {
              this.refreshCredits();
            }
            this.spinner.hide();
          }, error => {
            this.spinner.hide();
          });
        }
      });
  }
}

// export class FilesDataSource extends DataSource<any> {
//   _filterChange = new BehaviorSubject('');
//   _filteredDataChange = new BehaviorSubject('');
//
//   get filteredData (): any {
//     return this._filteredDataChange.value;
//   }
//
//   set filteredData (value: any) {
//     this._filteredDataChange.next(value);
//   }
//
//   get filter (): string {
//     return this._filterChange.value;
//   }
//
//   set filter (filter: string) {
//     this._filterChange.next(filter);
//   }
//
//   constructor (private usersService: FrontUserService ,
//                private _paginator: MatPaginator ,
//                private _sort: MatSort) {
//     super();
//     this.filteredData = this.usersService.users;
//   }
//
//   /** Connect function called by the table to retrieve one stream containing the data to render. */
//   connect (): Observable<any[]> {
//     const displayDataChanges = [
//       this.usersService.onUsersChanged ,
//       this._paginator.page ,
//       this._filterChange ,
//       this._sort.sortChange
//     ];
//
//     return observableMerge(...displayDataChanges).pipe(map(() => {
//       let data = this.usersService.users.slice();
//
//       data = this.filterData(data);
//
//       this.filteredData = [ ...data ];
//
//       data = this.sortData(data);
//
//       // Grab the page's slice of data.
//       const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
//       return data.splice(startIndex , this._paginator.pageSize);
//     }));
//   }
//
//   filterData (data) {
//     console.log(data);
//     if (!this.filter) {
//       return data;
//     }
//     return FuseUtils.filterArrayByString(data , this.filter);
//   }
//
//
//
//   sortData (data): any[] {
//     if (this._sort.active) {
//       localStorage.setItem('frontUserSort' , this._sort.active);
//       localStorage.setItem('frontUserSortDirection' , this._sort.direction);
//     }
//
//     let sortFromLS: any = localStorage.getItem('frontUserSort');
//     let sortDirFromLS: any = localStorage.getItem('frontUserSortDirection');
//     if (sortFromLS && sortDirFromLS) {
//       this._sort.active = sortFromLS;
//       this._sort.direction = sortDirFromLS;
//     }
//
//     if (!this._sort.active || this._sort.direction === '') {
//       if (!sortFromLS) {
//         return data;
//       }
//     }
//
//     return data.sort((a , b) => {
//       let propertyA: number | string = '';
//       let propertyB: number | string = '';
//
//       switch (this._sort.active ? this._sort.active : sortFromLS) {
//         case 'email':
//           [ propertyA , propertyB ] = [ a.email , b.email ];
//           break;
//           case 'sendInvite':
//           [ propertyA , propertyB ] = [ a.sendInvite , b.sendInvite ];
//           break;
//         case 'name':
//           [ propertyA , propertyB ] = [ (a.lastName + a.firstName) ,  (b.lastName + b.firstName) ];
//           break;
//         case 'clan':
//           [ propertyA , propertyB ] = [ (a.godMotherId && a.godFatherId && a.motherId && a.fatherId) , (b.godMotherId && b.godFatherId && b.motherId && b.fatherId)];
//           break;
//         case 'country':
//           [ propertyA , propertyB ] = [ a.country ? a.country.name : null , b.country ? b.country.name : null ];
//           break;
//         case 'canton':
//           [ propertyA , propertyB ] = [ a.city ? a.city.name : null , b.city ? b.city.name : null ];
//           break;
//         case 'targetGroup':
//           [ propertyA , propertyB ] = [ a.targetGroup ? a.targetGroup.id : null , b.targetGroup ? b.targetGroup.id : null ];
//           break;
//         case 'organization':
//           [ propertyA , propertyB ] = [ a.organization ? a.organization.name : null , b.organization ? b.organization.name : null ];
//           break;
//
//       }
//
//       const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
//       const valueB = isNaN(+propertyB) ? propertyB : +propertyB;
//       let direction = this._sort.direction ? this._sort.direction : sortDirFromLS;
//
//       return (valueA < valueB ? -1 : 1) * (direction === 'asc' ? 1 : -1);
//     });
//   }
//
//   disconnect () {
//   }
// }
